var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { activeNavLinkStyle, headerShellStyle, logoContainerStyle, logoImageStyle, logoLinkStyle, logoSubtitleStyle, mobileMenuButtonStyle, mobileMenuPanelStyle, mobileNavAreaStyle, mobileNavBarClosedStyle, mobileNavBarOpenStyle, mobileNavLinkStyle, mobileTopRowStyle, navAreaStyle, navBarStyle, navLinkBaseStyle, } from "./PublicHeader.styles";
var navItems = [
    {
        active: function (pathname) { return pathname === "/"; },
        label: "Início",
        to: "/",
    },
    {
        active: function (pathname) { return pathname === "/about"; },
        label: "Sobre",
        to: "/about",
    },
    {
        active: function (pathname) { return pathname === "/contact"; },
        label: "Contato",
        to: "/contact",
    },
];
export var PublicHeader = function () {
    var pathname = useLocation().pathname;
    var isDesktopNav = useMediaQuery("(min-width:768px)");
    var _a = useState(false), isMobileMenuOpen = _a[0], setIsMobileMenuOpen = _a[1];
    useEffect(function () {
        setIsMobileMenuOpen(false);
    }, [pathname]);
    useEffect(function () {
        if (isDesktopNav) {
            setIsMobileMenuOpen(false);
        }
    }, [isDesktopNav]);
    var renderNavLinks = function (isMobile) {
        if (isMobile === void 0) { isMobile = false; }
        return navItems.map(function (item) {
            var isActive = item.active(pathname);
            return (_jsx(RouterLink, __assign({ "aria-current": isActive ? "page" : undefined, style: isMobile
                    ? mobileNavLinkStyle
                    : isActive
                        ? activeNavLinkStyle
                        : navLinkBaseStyle, to: item.to }, { children: item.label }), item.label));
        });
    };
    return (_jsx("header", __assign({ style: headerShellStyle }, { children: _jsxs("nav", __assign({ "aria-label": "Navega\u00E7\u00E3o principal", style: isDesktopNav
                ? navBarStyle
                : isMobileMenuOpen
                    ? mobileNavBarOpenStyle
                    : mobileNavBarClosedStyle }, { children: [_jsxs("div", __assign({ style: !isDesktopNav ? mobileTopRowStyle : undefined }, { children: [_jsx(RouterLink, __assign({ "aria-label": "P\u00E1gina inicial ParticiPE", style: logoLinkStyle, to: "/" }, { children: _jsxs("div", __assign({ style: logoContainerStyle }, { children: [_jsx("img", { alt: "Logo ParticiPE", src: "".concat(process.env.PUBLIC_URL, "/images/logo-participe.png"), style: logoImageStyle }), _jsx("p", __assign({ style: logoSubtitleStyle }, { children: "Plataforma Digital de Participa\u00E7\u00E3o Cidad\u00E3" }))] })) })), !isDesktopNav ? (_jsx("button", __assign({ "aria-expanded": isMobileMenuOpen, "aria-label": isMobileMenuOpen
                                ? "Fechar menu principal"
                                : "Abrir menu principal", onClick: function () { return setIsMobileMenuOpen(function (isOpen) { return !isOpen; }); }, style: mobileMenuButtonStyle, type: "button" }, { children: isMobileMenuOpen ? _jsx(CloseRoundedIcon, {}) : _jsx(MenuRoundedIcon, {}) }))) : null] })), isDesktopNav ? (_jsx("div", __assign({ style: navAreaStyle }, { children: renderNavLinks() }))) : null, !isDesktopNav && isMobileMenuOpen ? (_jsx("div", __assign({ style: mobileMenuPanelStyle }, { children: _jsx("div", __assign({ style: mobileNavAreaStyle }, { children: renderNavLinks(true) })) }))) : null] })) })));
};
